import React from 'react';

const Gasto = ({Gasto}) =>  (
    <li className="gastos-realizados">
        <p>
            {Gasto.nombre}

            <span className="gasto">$  {Gasto.Cantidad} </span>


        </p>

    </li>

)
   

 
export default Gasto;